export const API_CONFIG = {
  baseURL: import.meta.env.PROD 
    ? 'https://api.singmystory.com'  // Replace with your production API URL when ready
    : 'http://localhost:3000'  // Local development server
} as const;